import { render, staticRenderFns } from "./course-resource.vue?vue&type=template&id=bafc630c&scoped=true"
import script from "./course-resource.vue?vue&type=script&lang=js"
export * from "./course-resource.vue?vue&type=script&lang=js"
import style0 from "./course-resource.vue?vue&type=style&index=0&id=bafc630c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafc630c",
  null
  
)

export default component.exports